/**
 * Mock Severity Percentage Data
 * Matches the actual API response structure
 */
export const mockSeverityPercentage = {
  success: true,
  'Severity-counts-Comparison': {
    high: {
      current: 2,
      previous: 3,
      percentageChange: -33.33,
    },
    medium: {
      current: 2,
      previous: 1,
      percentageChange: 100.0,
    },
    low: {
      current: 1,
      previous: 2,
      percentageChange: -50.0,
    },
    total: {
      current: 5,
      previous: 6,
      percentageChange: -16.67,
    },
  },
}
